var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 22.589,
    height: 22.589,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(-1528 -3089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    transform: "translate(1528 3089)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(1534 3095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M11.294,2.035c3.016,0,3.373.011,4.564.066a6.233,6.233,0,0,1,2.1.389,3.493,3.493,0,0,1,1.3.845,3.5,3.5,0,0,1,.845,1.3,6.287,6.287,0,0,1,.389,2.1c.054,1.19.065,1.548.065,4.563s-.011,3.373-.065,4.564a6.274,6.274,0,0,1-.389,2.1A3.74,3.74,0,0,1,17.955,20.1a6.233,6.233,0,0,1-2.1.389c-1.191.054-1.548.066-4.564.066s-3.373-.012-4.564-.066a6.233,6.233,0,0,1-2.1-.389,3.5,3.5,0,0,1-1.3-.845,3.5,3.5,0,0,1-.845-1.3,6.274,6.274,0,0,1-.389-2.1c-.054-1.191-.065-1.548-.065-4.564s.011-3.373.065-4.563a6.287,6.287,0,0,1,.389-2.1,3.5,3.5,0,0,1,.845-1.3,3.493,3.493,0,0,1,1.3-.845A6.233,6.233,0,0,1,6.73,2.1c1.191-.055,1.548-.066,4.564-.066m0-2.035C8.227,0,7.842.013,6.637.068A8.293,8.293,0,0,0,3.9.593a5.541,5.541,0,0,0-2,1.3,5.53,5.53,0,0,0-1.3,2A8.254,8.254,0,0,0,.068,6.638C.013,7.843,0,8.227,0,11.294s.013,3.452.068,4.657a8.254,8.254,0,0,0,.525,2.742,5.53,5.53,0,0,0,1.3,2,5.541,5.541,0,0,0,2,1.3,8.294,8.294,0,0,0,2.741.525c1.2.055,1.59.068,4.657.068s3.452-.013,4.657-.068A8.293,8.293,0,0,0,18.692,22a5.773,5.773,0,0,0,3.3-3.3,8.254,8.254,0,0,0,.525-2.742c.055-1.2.068-1.589.068-4.657s-.013-3.451-.068-4.656A8.254,8.254,0,0,0,22,3.9a5.53,5.53,0,0,0-1.3-2,5.541,5.541,0,0,0-2-1.3A8.293,8.293,0,0,0,15.951.068C14.746.013,14.361,0,11.294,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M11.294,5.494a5.8,5.8,0,1,0,5.8,5.8,5.8,5.8,0,0,0-5.8-5.8m0,9.565a3.765,3.765,0,1,1,3.765-3.765,3.765,3.765,0,0,1-3.765,3.765",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M18.679,5.265A1.356,1.356,0,1,1,17.324,3.91a1.355,1.355,0,0,1,1.355,1.355",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4c2e86eb478cec3e4a54ea06806f10ea.svg";
export { ForwardRef as ReactComponent };